import { TitleAndTraceRoute } from './components/TitleAndTraceRoute';
import UserSection from './components/UserSection';

/**
 * Header principal para las páginas del mantenedor
 * Muestra el título con breadcrumbs de navegación y los filtros globales (año/semestre)
 * El componente se adapta según la página: oculta filtros en páginas específicas
 *
 * Estructura:
 * - TitleAndTraceRoute: Título y breadcrumbs de navegación
 * - UserSection: Información del usuario autenticado
 * - FiltersSection: Selectores de año y semestre (condicional según página)
 *
 * Páginas sin filtros:
 * - Caracterización
 * - Gestión de Usuarios
 */
const HeaderMaintainer = () => {
  return (
    <header className="flex justify-between px-2 w-full flex-col md:flex-row gap-4">
      <TitleAndTraceRoute />

      <div className="flex flex-col text-gray-500 text-end gap-4">
        <UserSection />
      </div>
    </header>
  );
};

export default HeaderMaintainer;
